<template>
  <div>
    <div v-if="groupedItems.length === 0" class="alert alert-light border text-muted">
      Nenhum evento nesta seção.
    </div>

    <div v-else class="v2-group-list">
      <div class="v2-group" v-for="group in groupedItems" :key="group.nome">
        <div class="v2-group-header">
          <img :src="group.flag" alt="bandeira" class="v2-flag mr-2" @error="onFlagError" />
          <span>{{ group.nome }}</span>
        </div>

        <div class="v2-event-row" v-for="item in group.itens" :key="item._id">
          <div class="v2-event-main">
            <div class="v2-time-wrap">
              <span class="v2-time">{{ getHorario(item) }}</span>
              <span class="v2-live-elapsed" v-if="getTempoRodando(item)">{{ getTempoRodando(item) }}</span>
            </div>
            <span class="v2-title">{{ item.titulo || item.nome || "Evento" }}</span>
          </div>

          <div class="v2-actions">
            <button
              type="button"
              class="btn btn-dark btn-sm v2-action-btn"
              title="Visualizar"
              @click="$emit('visualizar', item)"
            >
              ↗
            </button>
            <span v-if="itensFavoritos[item._id]" class="badge badge-warning ml-2">Favorito</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "V2EventList",
  props: {
    itens: { type: Array, default: () => [] },
    filtroSituacao: { type: Array, default: () => [] },
    itensFavoritos: { type: Object, default: () => ({}) },
    gmt: { type: Number, default: -3 },
  },
  computed: {
    filteredItems() {
      return this.itens.filter((item) => this.filtroSituacao.includes(item.situacao));
    },
    groupedItems() {
      const groups = {};

      this.filteredItems.forEach((item) => {
        const nome = item.competicao || "Sem competição";
        if (!groups[nome]) {
          groups[nome] = {
            nome,
            flag: item.competicaoPaisUrl || "/assets/worldflag3.png",
            itens: [],
          };
        }
        groups[nome].itens.push(item);
      });

      return Object.values(groups);
    },
  },
  methods: {
    onFlagError(event) {
      event.target.src = "/assets/worldflag3.png";
    },
    getHorario(item) {
      if (item && item.dataHora != null && item.dataMinuto != null) {
        let hora = Number(item.dataHora);
        let minuto = Number(item.dataMinuto);

        if (!Number.isNaN(hora) && !Number.isNaN(minuto)) {
          try {
            const data = new Date();
            data.setHours(hora + 3 + parseInt(this.gmt, 10));
            data.setMinutes(minuto);

            hora = data.getHours();
            minuto = data.getMinutes();
          } catch (err) {
            // mantém horário bruto em caso de erro
          }

          return `${String(hora).padStart(2, "0")}:${String(minuto).padStart(2, "0")}`;
        }
      }

      const raw = item.hora || item.dataHora || item.data || "-";
      const match = String(raw).match(/\b\d{1,2}:\d{2}\b/);
      return match ? match[0] : "--:--";
    },
    getTempoRodando(item) {
      if (!item || item.situacao !== 3) {
        return "";
      }

      if (item.tempoJogo || item.tempoPartida || item.minutoJogo) {
        const valor = item.tempoJogo || item.tempoPartida || item.minutoJogo;
        return `${valor}min`;
      }

      if (item.dataHora == null || item.dataMinuto == null) {
        return "";
      }

      const inicio = new Date();
      inicio.setHours(Number(item.dataHora), Number(item.dataMinuto), 0, 0);

      const agora = new Date();
      let diff = Math.floor((agora.getTime() - inicio.getTime()) / 60000);

      if (diff < 0) {
        diff += 24 * 60;
      }

      if (diff < 0 || diff > 300) {
        return "";
      }

      return `${diff} min`;
    },
  },
};
</script>

<style scoped>
.v2-group-list {
  width: 100%;
}

.v2-group {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 10px;
  overflow: hidden;
}

.v2-group-header {
  border-bottom: 1px solid #ececec;
  padding: 7px 10px;
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
  display: flex;
  align-items: center;
}

.v2-event-row {
  padding: 8px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #f2f2f2;
  gap: 8px;
}

.v2-event-main {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #334155;
}

.v2-time {
  color: #475569;
  min-width: 44px;
}

.v2-time-wrap {
  min-width: 52px;
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.v2-live-elapsed {
  color: #16a34a;
  font-size: 12px;
  font-weight: 600;
}

.v2-title {
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v2-actions {
  display: flex;
  align-items: center;
}

.v2-action-btn {
  padding: 2px 8px;
  margin-left: 6px;
}

.v2-flag {
  width: 18px;
  height: 12px;
  object-fit: cover;
  border-radius: 2px;
}
</style>
